
import DigitalNatureWebComponent from "@digital-nature-ltd/web-component";
import template from "./templates/digital-nature-dismissable-message-template.html?raw"

class DigitalNatureDismissableMessageComponent extends DigitalNatureWebComponent
{
    constructor() {
        super({template: template});

        this.addEventListener("click", this);
    }

    handleClick (event)
    {
        this.remove();
    }
}

// add the custom element to the registry
customElements.define('digital-nature-dismissable-message', DigitalNatureDismissableMessageComponent);